import { WidgetType, WidgetConfigurationField, WidgetOptionConfigurationField } from 'domain/entity/widget';
import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface UpdateWidgetCriteria {
    widgetId: string;
    type: WidgetType;
    presetKey: string;
    configurationFields: WidgetConfigurationField[];
    optionFields: WidgetOptionConfigurationField[];
}

class UpdateWidgetCriteriaImpl implements UpdateWidgetCriteria {
    constructor(
        readonly widgetId: string,
        readonly type: WidgetType,
        readonly presetKey: string,
        readonly configurationFields: WidgetConfigurationField[],
        readonly optionFields: WidgetOptionConfigurationField[]
    ) {}
}

export class UpdateWidgetCriteriaBuilder {
    private widgetId: Option<string> = none;

    private type: Option<WidgetType> = none;

    private presetKey: Option<string> = none;

    private configurationFields: Option<WidgetConfigurationField[]> = none;

    private optionFields: Option<WidgetOptionConfigurationField[]> = none;

    static create = (): UpdateWidgetCriteriaBuilder => new UpdateWidgetCriteriaBuilder();

    withWidgetId = (widgetId: string): UpdateWidgetCriteriaBuilder => {
        this.widgetId = some(widgetId);
        return this;
    };

    withType = (type: WidgetType): UpdateWidgetCriteriaBuilder => {
        this.type = some(type);
        return this;
    };

    withPresetKey = (presetKey: string): UpdateWidgetCriteriaBuilder => {
        this.presetKey = some(presetKey);
        return this;
    };

    withConfigurationFields = (configurationFields: WidgetConfigurationField[]): UpdateWidgetCriteriaBuilder => {
        this.configurationFields = some(configurationFields);
        return this;
    };

    withOptionFields = (optionFields: WidgetOptionConfigurationField[]): UpdateWidgetCriteriaBuilder => {
        this.optionFields = some(optionFields);
        return this;
    };

    build = (): UpdateWidgetCriteria => {
        if (
            isNone(this.widgetId) ||
            isNone(this.type) ||
            isNone(this.presetKey) ||
            isNone(this.configurationFields) ||
            isNone(this.optionFields)
        ) {
            throw new ReferenceError('Undefined prop');
        }

        return new UpdateWidgetCriteriaImpl(
            this.widgetId.value,
            this.type.value,
            this.presetKey.value,
            this.configurationFields.value,
            this.optionFields.value
        );
    };
}
